import { Component, Input, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Workflow } from '@fry/booking/workflow-editor/lib/workflow.model';

// Type this form returns as result
export interface WorkflowEditFormResult {
  name: string;
}

export interface WorkflowEditFormOptions {
  workflow: Workflow;
}

// Controls should have same names as the Result to ensure correct form.value
type WorkflowEditFormControls = {[K in keyof WorkflowEditFormResult]: AbstractControl};

@Component({
    selector: 'eas-workflow-edit-form',
    templateUrl: './workflow-edit-form.component.html',
    styleUrls: ['./workflow-edit-form.component.css'],
    standalone: false
})
export class WorkflowEditFormComponent {
  @Input() workflow?: Workflow;

  public form: FormGroup;

  constructor(formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) data: WorkflowEditFormOptions,
              private dialogRef: MatDialogRef<WorkflowEditFormOptions, WorkflowEditFormResult>
             ) {
    this.workflow = data.workflow;
    const controls: WorkflowEditFormControls = {
      name: formBuilder.control(this.workflow?.name, Validators.required)
    };
    this.form = formBuilder.group(controls);
  }

  //
  // Actions
  //

  public onSave(): void {
    if (this.form.invalid) { return; }
    this.dialogRef.close(this.form.value);
  }

  public onCancel(): void {
    this.dialogRef.close(undefined);
  }
}
